// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class CitationService {
   $http: any
   $location: any
   $q: any
   $window: any
   availabilityService: any
   config: any
   recaptcha: any
   refworksSession: any
   styles: any
   translationService: any

//    static $inject = [
//     "$http",
//     "$q",
//     "$location",
//     "$window",
//     "configService",
//     "translationService",
//     "availabilityService",
//     "recaptchaService"
//   ]

   constructor($http: any, $q: any, $location: any, $window: any, configService: any, translationService: any, availabilityService: any, recaptcha: any) {
      this.cite = this.cite.bind(this)
      this.email = this.email.bind(this)
      this.addSenderEmailToMessageBody = this.addSenderEmailToMessageBody.bind(this)
      this.prepCitationExportOptions = this.prepCitationExportOptions.bind(this)
      this.getExportPath = this.getExportPath.bind(this)
      this.getNonQueryExportPath = this.getNonQueryExportPath.bind(this)
      this.getExternalExportPath = this.getExternalExportPath.bind(this)
      this.convertStyle = this.convertStyle.bind(this)
      this.$http = $http
      this.$q = $q
      this.$location = $location
      this.$window = $window
      this.translationService = translationService
      this.availabilityService = availabilityService
      this.recaptcha = recaptcha
      this.config = configService.data.citation
      this.styles = {
         citation: this.config.citation_styles.map((style: any) => this.convertStyle(style)),
         export:   this.config.export_styles.map((style: any) => this.convertStyle(style))
      }
      this.refworksSession = null
   }

   cite(documents: any, style: any) {
      const ids = this.normalize(documents).map((doc: any) => doc.id)
      const data = {
         ids: ids.join(','),
         format: style,
         l: this.$window.__summonLocale
      }
      const deferred = this.$q.defer()
      const reqOptions = {}
      // @ts-expect-error TS(2339) FIXME: Property 'headers' does not exist on type '{}'.
      if (this.refworksSession) { reqOptions.headers = {RefWorksSession: this.refworksSession} }

      this.$http.get(`/citation/cite?${$.param(data)}`, reqOptions).then((response: any) => {
         this.refworksSession = response.headers('RefWorksSession')
         return deferred.resolve(response.data)
      }
      , (response: any) => {
         this.refworksSession = null
         return deferred.reject(response.data)
      })

      return deferred.promise
   }

   email(options: any) {
      const docs = this.normalize(options.documents)
         const ids  = docs.map((doc: any) => doc.id)

         const data: any = {
            ids: ids.join(","),
            format: options.style,
            recipient: options.recipient,
            message: options.message,
            email_html: options.emailHtml,
            l: this.$window.__summonLocale
         }

         if (options.sender) {
            data.message = this.addSenderEmailToMessageBody(options)
         }

         // generate availability info when emailing the summon HTML format
      if ((options.style === 'summon') && options.emailHtml) {
        // ts-expect-error TS(2339) FIXME: Property 'uilang' does not exist on type '{ ids: s... Remove this comment to see the full error message
        data.uilang = this.availabilityService.rtaLocale()
         //ts-expect-error TS(2339) FIXME: Property 'availability_ids' does not exist on type... Remove this comment to see the full error message
         data.availability_ids = this.availabilityService.getAvailabilityIDs(docs).join(',')
         // ts-expect-error TS(2339) FIXME: Property 'docs_with_av_info' does not exist on typ... Remove this comment to see the full error message
         data.docs_with_av_info = {}
         for (var doc of docs) {
            var availabilityDocs = [doc].concat(doc.peer_documents || [])
            // ts-expect-error TS(2339) FIXME: Property 'docs_with_av_info' does not exist on typ... Remove this comment to see the full error message
            data.docs_with_av_info[doc.id] = availabilityDocs.map(avDoc => {
               const info = {
                  content_type: avDoc.content_type,
                  link: avDoc.link,
                  av_info: this.availabilityService.getAvailabilityInfo(avDoc)
               }
               // @ts-expect-error TS(2339) FIXME: Property 'availability_id' does not exist on type ... Remove this comment to see the full error message
               if (avDoc.availability_id) { info.availability_id = avDoc.availability_id }
               return info
            })
         }
      }

         // ✅ Enterprise flow
         return this.recaptcha.execute("citation_email", "emailCaptcha")

            .then((token: string) => {

               if (!token) {
               return this.$q.reject("no_recaptcha_token")
               }

               // IMPORTANT: what backend expects!
               data.captchaValidation = token

               // Send email only AFTER token is attached
               return this.$http.post("/citation/email", data)
            })

            .then((response: any) => {
               return response.data
            })

            .catch((err: any) => {
               console.error("Email send failed:", err)
               throw err
            })
   }

   addSenderEmailToMessageBody(options: any) {
      let senderText = 'From: ' + options.sender
      if (options.message) {
         senderText += '\n\n'
      }
      return senderText + options.message // add the sender to the message
   }

   // prepare for dropdowns
   prepCitationExportOptions(documents: any, options: any) {
      return options.forEach((style: any) => {
         style.target = "_blank"
         switch (style.name) {
            case "refworks": case "easybib":
               return style.href = this.getExternalExportPath(documents, style.name)
            case "citace":
               var url = this.$location.protocol() + '://' + this.$location.host() + (this.$location.port() && (this.$location.port() !== '80') ? ':' + this.$location.port() : '')
               // Forced to "endnote", citace doesn't work with "citace" name because of an unexpected reason.
               return style.href = style.url + url + this.getNonQueryExportPath(documents, "endnote")
            default:
               return style.href = style.name === 'none' ? undefined : this.getExportPath(documents, style.name, style.file_name)
         }
      })
   }

   getExportPath(documents: any, style: any, file_name: any) {
      const ids = this.normalize(documents).map((doc: any) => doc.id)
      const data = {
         ids: ids.join(','),
         format: style
      }
      // @ts-expect-error TS(2339) FIXME: Property 'file_name' does not exist on type '{ ids... Remove this comment to see the full error message
      if (file_name) { data.file_name = file_name.toLowerCase() }
      return `/citation/export?${$.param(data)}`
   }

   getNonQueryExportPath(documents: any, style: any) {
      const ids = this.normalize(documents).map((doc: any) => doc.id)
      return `/citation/export/${ids.join(',')}/${style}`
   }

   getExternalExportPath(documents: any, format: any) {
      const data =
      {ids: _.pluck(this.normalize(documents), 'id').join(",")}
      return `/citation/${format}?${$.param(data)}`
   }

   normalize(data: any) {
      if (angular.isArray(data)) {
         return data
      } else {
         return [data]
      }
   }

   convertStyle(style: any) {
      return {
         name: style.alias || style.name,
         file_name: style.label,
         text: style.description ?
            this.translationService.translate(`${style.label} (${style.description})`)
            :
            this.translationService.translate(style.label),
         alternate: style.alternate,
         url: style.url
      }
   }
}

CitationService.$inject = ['$http', '$q', '$location', '$window', 'configService', 'translationService', 'availabilityService', 'recaptchaService']

angular.module('summonApp.services')
   .service('citationService', CitationService)
